import { render, staticRenderFns } from "./work_detail.vue?vue&type=template&id=5631db5a&scoped=true"
import script from "./work_detail.vue?vue&type=script&lang=js"
export * from "./work_detail.vue?vue&type=script&lang=js"
import style0 from "./work_detail.vue?vue&type=style&index=0&id=5631db5a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631db5a",
  null
  
)

export default component.exports